export const defaultSelectedDate = () => {
    let fechaActual = new Date();

// Restar un mes a la fecha actual
    fechaActual.setMonth(fechaActual.getMonth() - 1);

// Obtener el día, mes y año
    let dia = fechaActual.getDate();
    let mes = fechaActual.getMonth() + 1; // Nota: Los meses comienzan desde 0, por lo que se suma 1
    let anio = fechaActual.getFullYear();

// Formatear la fecha en dd-MM-yyyy
    return `${dia.toString().padStart(2, '0')}-${mes.toString().padStart(2, '0')}-${anio}`;



};
export const defaultSelectedDateUp = () => {
    let fechaActual = new Date();

// Obtener el día, mes y año
    let dia = fechaActual.getDate();
    let mes = fechaActual.getMonth() + 1; // Nota: Los meses comienzan desde 0, por lo que se suma 1
    let anio = fechaActual.getFullYear();

// Formatear la fecha en dd-MM-yyyy
    return `${dia.toString().padStart(2, '0')}-${mes.toString().padStart(2, '0')}-${anio}`;
};

export default {
    params: {
        year_month_from: defaultSelectedDate(),
        year_month_up: defaultSelectedDateUp(),
        type_query:'1',
        branchoffice_id: null,
    },
    loading: {
        module: false
    },
};



// WEBPACK FOOTER //
// ./src/modules/excel-inventory/state.js